import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, Menu, MenuItem, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { MoreVert } from '@mui/icons-material';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import KeyboardDoubleArrowUpRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowUpRounded';
import SearchIcon from '@mui/icons-material/Search';
import MaterialButton from '../../../../../components/MaterialButton';
import MaterialTypography from '../../../../../components/MaterialTypography';
import AddTestCase from '../Sidebar/components/AddTestCase';

export const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
        case "active":
            return "#206124";
        case "draft":
            return "#BB360F";
        case "in review":
            return "#184DA0";
        case "outdated":
            return "#F98E09";
        case "rejected":
            return "#EF4438";
        default:
            return "#627D8B";
    }
};



const MainContent = ({ openAddTestCase, setOpenAddTestCase, testCaseData, steps, setSteps, handleAddStep, handleStepChange, handleDeleteStep, handleAddTestCase, testCases, headerName, handleTestCaseDataChange, selectedProject, handleSaveTestCase, handleDeleteTestCase, handleEditTestCase, editingTestCaseId, handleCloseAddTestCase }) => {
    // const [testCases, setTestCases] = useState([]); // Removed local state for testCases
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedTestCaseId, setSelectedTestCaseId] = useState(null);
    const [filteredTestCases, setFilteredTestCases] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        setFilteredTestCases(testCases || []);
    }, [testCases]);

    const handleSearchChange = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        const filtered = (testCases || []).filter(
            (testCase) =>
                String(testCase.id).toLowerCase().includes(query) ||
                testCase.title.toLowerCase().includes(query)
        );
        setFilteredTestCases(filtered);
    };

    const handleMenuClick = (event, testCaseId) => {
        setAnchorEl(event.currentTarget);
        setSelectedTestCaseId(testCaseId);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedTestCaseId(null);
    };

    const handleEdit = () => {
        if (selectedTestCaseId) {
            handleEditTestCase(selectedTestCaseId);
            handleMenuClose();
        }
    };

    const handleDelete = () => {
        if (selectedTestCaseId) {
            handleDeleteTestCase(selectedTestCaseId);
            handleMenuClose();
        }
    };


    return (
        <div style={styles.container}>
            <div style={styles.headerSection}>
                <h2 style={styles.title}>{headerName || 'Select a Module'}</h2>
                <div style={styles.newDivcontainer}>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search by ID or Title"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        style={styles.searchInput}
                        InputProps={{
                            style: styles.searchInputProps,
                        }}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                    <MaterialButton variant="contained" color="dark" size='small' onClick={handleAddTestCase}>
                        Add Test Case
                    </MaterialButton>
                </div>

            </div>
            <table style={styles.table}>
                <thead style={styles.thead}>
                    <tr style={styles.headerRow}>
                        <th style={styles.headerCell}>ID</th>
                        <th style={styles.headerCell}>Title</th>
                        <th style={styles.headerCell}>Priority</th>
                        <th style={styles.headerCell}>State</th>
                        <th style={styles.headerCell}>Owner</th>
                        <th style={styles.headerCell}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredTestCases.length > 0 ? (
                        filteredTestCases.map((testCase) => (
                            <tr key={testCase.id} style={styles.bodyRow}>
                                <td style={styles.bodyCell} data-label="ID">
                                    {testCase.case_id}
                                </td>
                                <td style={styles.bodyCell} data-label="Title">
                                    {testCase.title}
                                </td>
                                <td style={styles.bodyCell} data-label="Priority">
                                    <Box display="flex" alignItems="center" gap={1}>
                                        {testCase.priority === 'High' && (
                                            <>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '60%', backgroundColor: 'rgba(255, 0, 0, 0.1)', padding: '3px', borderRadius: '4px' }}>
                                                    <ArrowUpwardRoundedIcon sx={{ color: 'red' }} />
                                                    <Typography variant="caption" sx={{ color: 'red' }}>High</Typography>
                                                </Box>
                                            </>
                                        )}
                                        {testCase.priority === 'Low' && (
                                            <>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '50%', backgroundColor: 'rgba(25, 243, 47, 0.1)', padding: '3px', borderRadius: '4px' }}>
                                                    <ArrowDownwardRoundedIcon sx={{ color: 'green' }} />
                                                    <Typography variant="caption" sx={{ color: 'green' }}>Low</Typography>
                                                </Box>
                                            </>
                                        )}
                                        {testCase.priority === 'Medium' && (
                                            <>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '70%', backgroundColor: 'rgba(249, 227, 59, 0.1)', padding: '3px', borderRadius: '4px' }}>
                                                    <RemoveRoundedIcon sx={{ color: '#F5A92C' }} />
                                                    <Typography variant="caption" sx={{ color: '#F5A92C' }}>Medium</Typography>
                                                </Box>
                                            </>
                                        )}
                                        {testCase.priority === 'Critical' && (
                                            <>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '70%', backgroundColor: 'rgba(252, 52, 52, 0.1)', padding: '3px', borderRadius: '4px' }}>
                                                    <KeyboardDoubleArrowUpRoundedIcon sx={{ color: '#8B0000' }} />
                                                    <Typography variant="caption" sx={{ color: '#8B0000' }}>Critical</Typography>
                                                </Box>
                                            </>
                                        )}
                                    </Box>
                                </td>
                                <td
                                    style={{
                                        ...styles.bodyCell,
                                        color: getStatusColor(testCase.test_state),
                                    }}
                                    data-label="State"
                                >
                                    {testCase.test_state}
                                </td>
                                <td style={styles.bodyCell} data-label="Owner">
                                    {testCase.owner_name}
                                </td>
                                <td style={styles.bodyCell} data-label="Action">
                                    <IconButton
                                        size="small"
                                        onClick={(event) => handleMenuClick(event, testCase.id)}
                                    >
                                        <MoreVert />
                                    </IconButton>
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl) && selectedTestCaseId === testCase.id}
                                        onClose={handleMenuClose}
                                    >
                                        <MenuItem onClick={handleEdit}>Edit Test Case</MenuItem>
                                        <MenuItem onClick={handleDelete}>Delete</MenuItem>
                                    </Menu>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" style={styles.noDataCell}>
                                No test cases available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <Dialog open={openAddTestCase} onClose={handleCloseAddTestCase}
                PaperProps={{
                    sx: {
                        width: '90%',
                        height: '600px',
                        maxWidth: 'none',
                    },
                }}>
                <DialogTitle sx={{ borderBottom: '1px solid #ccc', padding: '8px 16px' }}>
                    <MaterialTypography variant='h6' color='dark' fontWeight='bold'>{editingTestCaseId ? 'Edit Test Case' : 'Add Test Case'}</MaterialTypography>
                </DialogTitle>
                <DialogContent>
                    <AddTestCase testCaseData={testCaseData} steps={steps} setSteps={setSteps} handleAddStep={handleAddStep} handleStepChange={handleStepChange} handleDeleteStep={handleDeleteStep} handleTestCaseDataChange={handleTestCaseDataChange} selectedProject={selectedProject} />
                </DialogContent>
                <DialogActions sx={{ borderTop: '1px solid #ccc', padding: '8px 16px' }}>
                    <MaterialButton variant='outlined' size='small' color='error' onClick={handleCloseAddTestCase}>Cancel</MaterialButton>
                    <MaterialButton variant='contained' size='small' color='dark' onClick={handleSaveTestCase}>
                        {editingTestCaseId ? 'Update' : 'Save'}
                    </MaterialButton>
                </DialogActions>
            </Dialog>
        </div>
    )
}

const styles = {
    container: {
        padding: '0px',
        width: '100%',
        margin: '0 auto',
        fontFamily: 'Montserrat, sans-serif',
        overflowX: 'auto',
        color: '#465155',
    },
    headerSection: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px',
        flexWrap: 'wrap',
        gap: '10px',
    },
    newDivcontainer: {
        gap: '10px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    title: {
        margin: 0,
        color: '#333',
        fontSize: '16px',
    },
    searchInput: {
        width: '280px',
    },
    searchInputProps: {
        fontSize: '14px',
    },
    heading: {
        textAlign: 'center',
        marginBottom: '20px',
        color: '#5c6cbf',
        fontSize: '10px',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        backgroundColor: '#fff',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        minWidth: '770px',
        fontSize: '11px',
    },
    thead: {
        backgroundColor: '#1976d2',
        color: '#fff',
    },
    headerRow: {
        backgroundColor: '#ffffff',
        color: 'grey',
        fontSize: '14px'
    },
    headerCell: {
        padding: '3px 15px',
        textAlign: 'left',
        borderBottom: '2px solid #ddd',
        whiteSpace: 'nowrap',
    },
    bodyRow: {
        borderBottom: '1px solid #ddd',
        transition: 'background-color 0.3s',
    },
    bodyCell: {
        padding: '4px 15px',
        textAlign: 'left',
        position: 'relative',
        whiteSpace: 'nowrap',
    },
    noDataCell: {
        padding: '10px',
        textAlign: 'center',
        color: '#888',
    },
};

export default MainContent

